import multiApiClient from "./base";

export const PACKAGE_TYPES = ["XS", "S", "M", "L1", "L2", "L3", "L5", "XL"];

export const PackageMappingsApi = {
  getPackageMappings: () => multiApiClient.get("/package_mappings/"),

  getPackageTypes: () => multiApiClient.get("/package_mappings/types"),

  createPackageMapping: (data) =>
    multiApiClient.post("/package_mappings/", data),

  updatePackageMapping: (id, data) =>
    multiApiClient.put(`/package_mappings/${id}`, data),

  deletePackageMapping: (id) =>
    multiApiClient.delete(`/package_mappings/${id}`),

  // CSV
  uploadCsv: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return multiApiClient.post("/package_mappings/csv/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  checkCsvExists: () => multiApiClient.get("/package_mappings/csv/exists"),

  previewCsv: () => multiApiClient.get("/package_mappings/csv/preview"),

  downloadCsv: () =>
    multiApiClient.get("/package_mappings/csv/download", {
      responseType: "blob",
    }),

  // SFTP
  listSftpCredentials: () => multiApiClient.get("/package_mappings/sftp/"),

  getActiveSftpCredential: () =>
    multiApiClient.get("/package_mappings/sftp/active"),

  createSftpCredential: (data) =>
    multiApiClient.post("/package_mappings/sftp/", data),

  updateSftpCredential: (id, data) =>
    multiApiClient.put(`/package_mappings/sftp/${id}`, data),

  deleteSftpCredential: (id) =>
    multiApiClient.delete(`/package_mappings/sftp/${id}`),

  activateSftpCredential: (id) =>
    multiApiClient.post(`/package_mappings/sftp/${id}/activate`),

  testSftp: (data) => multiApiClient.post("/package_mappings/sftp/test", data),

  testSftpCredential: (id) =>
    multiApiClient.post(`/package_mappings/sftp/${id}/test`),

  refreshCsvFromSftp: () =>
    multiApiClient.post("/package_mappings/sftp/refresh"),

  downloadCsvFromSftpCredential: (id) =>
    multiApiClient.post(`/package_mappings/sftp/${id}/download`),

  /** Re-assign packages for all SKUs (or one via ?sku=). */
  assignPackages: (sku) =>
    multiApiClient.post("/package_mappings/assign", null, {
      params: sku ? { sku } : undefined,
    }),
};
